import { AvatarProps, Avatar as MantineAvatar } from '@mantine/core';

import { getUserName } from '@/shared/helpers/utils';

import classes from './Avatar.module.css';

type TAvatarProps = {
	fullName: string;
} & AvatarProps;

export const Avatar = ({ fullName }: TAvatarProps) => (
	<MantineAvatar classNames={classes} size="lg" src={null} alt={fullName}>
		{getUserName(fullName, 'initials')}
	</MantineAvatar>
);
